﻿import { useColorScheme, WIcon } from "@mobility-item-page/client";
import { BrandURL } from "@mobility-item-page/types";
import { TargetType } from "@mobility-item-page/utilities/client";
import { useValidDealerItemContext } from "../context/DealerItemProviderContext.tsx";
import { useTracking } from "../utils/pulseHelper.ts";
import { ScreenReaderSeparator } from "./ScreenReaderSeparator.tsx";

export const SafetyElementHighlight = () => {
  const {
    organisationData: { safetyElements, memberAssociations },
    external: { brand },
  } = useValidDealerItemContext();
  const { trackClickMemberAssociationLink } = useTracking();
  const colorScheme = useColorScheme();
  const host = BrandURL[brand as keyof typeof BrandURL];

  return (
    <>
      {memberAssociations.map((association) => {
        const url = association.link?.url;
        const externalLink = url ? new URL(url).host.replace(/^(?:www|local|dev)\./, "") !== host : false;
        return (
          <>
            <div className="border-t -mx-16" />
            <div className="flex items-center gap-16 my-16" key={association.title}>
              {association.logoObject && (
                <img
                  className="w-[58px]"
                  src={
                    colorScheme === "dark" ? association.logoObject.darkModeLogo : association.logoObject.lightModeLogo
                  }
                  alt={`${association.title} logo`}
                />
              )}
              <div className="min-h-[58px]">
                <h3 className="text-body mb-4 hyphens-auto">{association.title}</h3>
                {url && (
                  <a
                    className="flex items-center gap-4 text-detail"
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      trackClickMemberAssociationLink({
                        targetTitle: association.title,
                        linkUrl: url,
                        targetType: externalLink ? TargetType.ExternalContent : TargetType.Page,
                      })
                    }
                  >
                    {association.link?.text}
                    {externalLink && (
                      <>
                        <ScreenReaderSeparator />
                        <WIcon name="LinkExternal" size="12px" />
                      </>
                    )}
                  </a>
                )}
              </div>
            </div>
          </>
        );
      })}
      {safetyElements?.highlight && (
        <>
          <div className="border-t -mx-16" />
          <div className="flex items-center gap-16 my-16">
            <img
              className="h-[58px]"
              src={safetyElements.highlight.logoUrl}
              alt={`${safetyElements.highlight.title} logo`}
            />
            <div>
              <h3 className="text-body m-0">{safetyElements.highlight.title}</h3>
              <p className="text-detail mb-0">{safetyElements.highlight.description}</p>
            </div>
          </div>
        </>
      )}
    </>
  );
};
